import { Component, input } from "@angular/core";

@Component({
  selector: "app-clock",
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      [class]="'size-' + size()"
    >
      <circle cx="12" cy="12" r="9" stroke-dasharray="3 3" />
      <path d="M12 7v5l3 2" />
    </svg>
  `,
})
export class Clock {
  size = input("6");
}
